module.exports = {"private":true,"main":"./LoadingBlocker.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/frags/LoadingBlocker/package.json
// module id = 842
// module chunks = 0 1